export const locale = {
  lang: 'fr',
  data: {
    TOOLBAR: {
      ACCOUNT_AREA: 'Type de compte',
      ACCOUNT_AREAS: { CUSTOMER: 'Espace client', LABORATORY: 'Espace laboratoire' },
      API_CREDENTIALS: "Clés d'API",
      APPLICATION_SETTINGS: "Paramètres de l'application",
      COLOR_THEMES_TITLE: 'Thème',
      COLOR_THEMES: { LIGHT: 'Clair', DARK: 'Sombre', SYSTEM: 'Système' },
      LOGOUT: 'Déconnexion',
      MY_ACCOUNT: 'Mon compte',
      USER_MANAGEMENT: 'Gestion des utilisateurs',
    },
  },
};
